import { Injectable } from '@angular/core';
import moment from 'moment';

const EXPIRES_IN = 'expires_in';
export const USERID_TOKEN = 'userid_token';
export const IMPERSONATE_AUTH_TOKEN = 'impersonatedAuthToken';
export const IMPERSONATED_EXPIRES_IN = 'impersonatedExpiresIn';
export const IS_IMPERSONATION_MODE_ON = 'isImpersonationModeOn';
export const IMPERSONATED_LOCALE_ID = 'imperson_localeID';
export const IMPERSONATED_USER_INFO_TOKEN = 'imperson_userInfo';
export const IMPERSONATED_USER_EMAIL = 'impersonatedUserEmail';
const USERID_INFO = 'userInfo';
export const NOT_IN_PLATFORM_USER = 'not_in_platform_user';

export interface IUserSessionResponse {
  token: string;
  emailId: string;
  firstName?: string;
  lastName?: string;
  expires_in: number;
  user_id?: number;
}

@Injectable()
export class LoggedInService {
  setSession(userSessionResponse: IUserSessionResponse): void {
    const { token, expires_in = 3600, user_id } = userSessionResponse;
    const expiresAt = moment().add(expires_in, 'second');
    if (user_id == null) {
      localStorage.setItem(NOT_IN_PLATFORM_USER, '1');
    }
    localStorage.setItem(USERID_TOKEN, token);

    // Only the non-PII user id is persisted to localStorage (Cycode: avoid storing PII)
    localStorage.setItem(USERID_INFO, JSON.stringify({ id: user_id }));
    localStorage.setItem(EXPIRES_IN, JSON.stringify(expiresAt.valueOf()));
  }

  isLoggedIn(): boolean {
    if (moment().isBefore(this.getExpirationDate())) {
      return true;
    }
    // invalidate the session token
    localStorage.setItem(USERID_TOKEN, '');
    return false;
  }

  private getExpirationDate(): moment.Moment {
    const expiresAt = JSON.parse(localStorage.getItem(EXPIRES_IN));
    return moment(expiresAt);
  }
}
